module.exports = __webpack_public_path__ + "img/content-white-icon.b54dc438.png";